export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11739.5d55d534.jpg";